import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { getHTTPErrors, HTTPErrorsCountApiResponse } from "../../../api/MaintenanceRequests";
import { LoadingState } from "../../../navigation/LoadingState";
import { Area } from "../../../navigation/tree/Area";
import {Trans} from "react-i18next"
import classes from "../../Statistics.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";

interface IProps {
    area: Area
    nodePath: string,
    startDateTimestamp: number,
    endDateTimestamp: number
    mediaspotSerials?:string[]
}

export const HTTPErrors = (props: IProps) => {

    const [httpErrors, setHTTPErrors] = useState<HTTPErrorsCountApiResponse|undefined>(undefined)
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.LOADING)

      
    const loadHTTPErrors = async() => {
        setLoadingState(LoadingState.LOADING)
        const httpErrorsResponse = await getHTTPErrors(props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.area.mediaspot?.serial, props.mediaspotSerials)
        if(httpErrorsResponse.data){
            setHTTPErrors(httpErrorsResponse.data)
            setLoadingState(LoadingState.LOADED)
        }else {
            setLoadingState(LoadingState.ERROR)
        }
    }

    // Each time props are updated, reload data
    useEffect(() => {
        loadHTTPErrors()
    }, [props.startDateTimestamp, props.endDateTimestamp, props.nodePath])

    return (
        <>
         {
            loadingState === LoadingState.LOADING ?
                <div className={classes.StatisticsLoaderContainer}>
                    <Loader type="Oval" color="#4185F4" height={50} width={50}/>
                </div> : null
        }
        {
            loadingState === LoadingState.ERROR ?
                <div className={classes.StatisticsErrorContainer}>
                    <label><Trans>AnErrorOccurredDuringLoading</Trans>...</label>
                    <br />
                    <button className={classes.RetryButton} onClick={() => loadHTTPErrors()}><FontAwesomeIcon icon={faRedo} size={"sm"} color={"#404040"}/>&nbsp;&nbsp;<Trans>Reload</Trans></button>
                </div> : null
        }
            
        {
            loadingState === LoadingState.LOADED && httpErrors ?

                httpErrors.length === 0 ? <div className={classes.StatisticsNoDataContainer}>
                    <label><Trans>NoDataOnThisPeriod</Trans></label>
                </div> :

                <table>
                    <thead>
                        <tr>
                            <th>Code HTTP</th>
                            <th>Occurences</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            httpErrors.map(httpError => {
                                return (
                                    <tr>
                                        <td>{httpError.status}</td>
                                        <td>{httpError.count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                : undefined
            }
        </>
    )
}